import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class UpdateOnskatDatumCommand extends BasicCommand<UpdateOnskatDatumCommand> {
    readonly atgardGuid: string;
    readonly onskatDatum?: Date;

    static readonly $type = "UpdateOnskatDatumCommand";
    static readonly $groupKey = "OnskatDatum";

    get primaryKey(): IPrimaryKey<UpdateOnskatDatumCommand> {
        return {
            guid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, onskatDatum: Date) {
        super(UpdateOnskatDatumCommand.$type, UpdateOnskatDatumCommand.$groupKey, CommandType.Replace);
        this.onskatDatum = onskatDatum;
        this.atgardGuid = atgardGuid;
    }
}
